import type { Components, Theme } from "@mui/material";
import { getPaletteColor } from "./util";

declare module "@mui/material/Radio" {
  interface RadioPropsColorOverrides {
    cyan: true;
    green: true;
    yellow: true;
    orange: true;
    magenta: true;
    purple: true;
    dark: true;
  }
}

export const covestroMuiRadio: Components<Theme>["MuiRadio"] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      "&:hover": {
        color: getPaletteColor(theme, ownerState.color)?.main,
      },
    }),
  },
};
